var map = {
	"./common/empty.png": 43335,
	"./common/frame-corner-bottom-left.png": 15643,
	"./common/frame-corner-bottom-right.png": 15236,
	"./common/frame-corner-top-left.png": 25245,
	"./common/frame-corner-top-right.png": 702,
	"./common/gift.png": 76416,
	"./common/hot.gif": 74870,
	"./event/top-bg.png": 67538,
	"./event/top-right.png": 55653,
	"./event/top-shell-bg.png": 54545,
	"./footer/border-body.png": 12533,
	"./footer/border-top.png": 39816,
	"./header/dropdown-arrow.png": 89677,
	"./header/menu-toggle.png": 97226,
	"./header/mobile-arrow.png": 60372,
	"./home/banner-bg.png": 87048,
	"./home/category-favorite.webp": 29728,
	"./home/category-hot-active.png": 53563,
	"./home/category-hot.png": 68278,
	"./home/category-popular.webp": 90229,
	"./home/category-recent-active.png": 40371,
	"./home/category-recent.png": 64702,
	"./home/category-recent.webp": 2119,
	"./home/category-slots.webp": 63109,
	"./home/event-card-corner-bottom-left.png": 1331,
	"./home/event-card-corner-bottom-right.png": 84796,
	"./home/event-card-corner-top-left.png": 59877,
	"./home/event-card-corner-top-right.png": 5958,
	"./home/frame-corner-bottom-left.png": 99701,
	"./home/frame-corner-bottom-right.png": 58326,
	"./home/frame-corner-top-left.png": 42339,
	"./home/frame-corner-top-right.png": 27212,
	"./home/game-section-header-bg.png": 28414,
	"./home/jackpot-bg.png": 92282,
	"./home/notice-icon.webp": 5409,
	"./home/page-bg.png": 17413,
	"./home/redeem-code-icon.png": 83464,
	"./home/search-active.png": 66737,
	"./home/search.png": 61560,
	"./login/exit-confirm-bg.png": 23067,
	"./login/popup-bg.png": 88658,
	"./notification/bg-top1.png": 67758,
	"./person/avatar.png": 57061,
	"./person/bg-vip.png": 18905,
	"./person/bg-vipBottom.png": 1388,
	"./person/bg-vipPc.png": 62498,
	"./person/icon-Deposit.png": 69284,
	"./person/icon-DepositVip.png": 44003,
	"./person/icon-History.png": 59574,
	"./person/icon-Install.png": 87875,
	"./person/icon-Notification.png": 64769,
	"./person/icon-Senha.png": 62185,
	"./person/icon-Transaction.png": 30370,
	"./person/icon-Withdraw.png": 27734,
	"./person/icon-arrow.png": 62049,
	"./person/icon-betsVip.png": 42979,
	"./person/icon-exchange.png": 45899,
	"./person/icon-service.png": 77567,
	"./person/icon_Wallet.png": 58885,
	"./person/icon_copy.png": 54169,
	"./person/icon_logout.png": 50856,
	"./person/icon_notification.png": 88035,
	"./person/vip-center-bg.png": 87971,
	"./share/TreasureChest.png": 15442,
	"./share/TreasureLock.png": 38644,
	"./share/TreasureUnLock.png": 49393,
	"./share/bg-shareMoney.png": 45041,
	"./share/bg-sharePeople.png": 12732,
	"./share/bg-top.png": 16921,
	"./share/facebook.png": 84522,
	"./share/icon_fackbook.png": 85316,
	"./share/icon_howShare.png": 28265,
	"./share/icon_ins.png": 97040,
	"./share/icon_inviteDate.png": 5429,
	"./share/icon_telegram.png": 60959,
	"./share/icon_tiktok.png": 85828,
	"./share/icon_whatsapp.png": 32076,
	"./share/icon_x.png": 20768,
	"./share/icon_youtube.png": 76843,
	"./share/invite_banner1.png": 63923,
	"./share/invite_banner2.png": 89432,
	"./share/invite_banner3.png": 62145,
	"./share/invite_banner4.png": 95406,
	"./share/proxy.png": 61056,
	"./share/redemption-code-title.png": 1502,
	"./share/share_bg.png": 2199,
	"./share/trumpet.png": 20723,
	"./sidebar/affiliate-active.png": 10713,
	"./sidebar/affiliate.png": 23920,
	"./sidebar/copy.png": 67370,
	"./sidebar/customer-service.png": 86227,
	"./sidebar/hot-bg.png": 63366,
	"./sidebar/invite-free.png": 4007,
	"./sidebar/language-arrow.png": 66795,
	"./sidebar/menu-item-border.png": 5235,
	"./sidebar/path-arrow.png": 66424,
	"./sidebar/promotion-active.png": 83795,
	"./sidebar/promotion.png": 15454,
	"./sidebar/redemption-code-active.png": 86063,
	"./sidebar/redemption-code.png": 57026,
	"./sidebar/refresh.png": 29964,
	"./sidebar/share-panel-bg.png": 74677,
	"./sidebar/sidebar-border.png": 74718,
	"./sidebar/social-media-active.png": 78860,
	"./sidebar/social-media.png": 63559,
	"./sidebar/telegram.gif": 34023,
	"./sidebar/vip-active.png": 35753,
	"./sidebar/vip-badge.png": 82694,
	"./sidebar/vip.png": 35424,
	"./signIn/suo.png": 2702,
	"./signIn/vipicon.png": 34995,
	"./signIn/vipiconact.png": 70447,
	"./tabbar/active-corner-bottom-left.png": 29053,
	"./tabbar/active-corner-bottom-right.png": 42238,
	"./tabbar/active-corner-top-left.png": 48443,
	"./tabbar/active-corner-top-right.png": 63396,
	"./tabbar/affiliate-active.png": 11287,
	"./tabbar/affiliate.png": 64026,
	"./tabbar/home-active.png": 19207,
	"./tabbar/home.png": 9738,
	"./tabbar/menu-active.png": 40087,
	"./tabbar/menu.png": 7162,
	"./tabbar/profile-active.png": 98553,
	"./tabbar/profile.png": 99568,
	"./tabbar/sport.png": 84241,
	"./tabbar/vip-active.png": 3659,
	"./tabbar/vip.png": 21254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96919;